import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = sanityClient({
  projectId: "m8cego7v",
  dataset: "production",
  apiVersion: "2022-07-01",
  useCdn: true,
  token:
    "skVC4XNexWOAl2LO2pbqwO08ZPYjU8VzDThb8T2orK7hTRZEmPFOb6kCyhsNvtk0KKXnr4wUNE0qKfPgnHk5jnMUKxiAZWCWqe27RiMHm9a7AKnS4RSJDbcj8r9CQKjSVpgTa836S9NAvxR0bn2eeFMsFRGCCwqlHJsb1GQRbYiSvlJ8vxJN",
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
